import { Badge } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

const ActionBadge = ({ children, onClick }) => (
  <button
    type="button"
    className="inline-flex rounded-[8px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2173FF]/50"
    onClick={onClick}
  >
    <Badge variant="neutral" size="medium">
      {children}
    </Badge>
  </button>
);

/**
 * Bulk action bar (CT-4200) — shown above the inbox table while rows are selected.
 */
const RequestsBulkBar = ({ count, onApprove, onReject, onReassign, onClear }) => {
  const { t } = useTranslation('admin-studio');

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-lg bg-white/[0.04] px-3 py-2">
      <p className="text-[13px] font-medium text-content">
        {t('integrations.requests.inbox.bulk.selected', { count })}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <ActionBadge onClick={onApprove}>{t('integrations.requests.inbox.actions.approve')}</ActionBadge>
        <ActionBadge onClick={onReject}>{t('integrations.requests.inbox.actions.reject')}</ActionBadge>
        <ActionBadge onClick={onReassign}>{t('integrations.requests.inbox.bulk.reassign')}</ActionBadge>
      </div>
      <button
        type="button"
        className="ml-auto text-[13px] text-content-faint transition-colors hover:text-content"
        onClick={onClear}
      >
        {t('integrations.requests.inbox.bulk.clear')}
      </button>
    </div>
  );
};

export default RequestsBulkBar;
